import { fetchClientsPaginated } from '../../api/workspaces/clientApi';
import { MAX_CLIENT_IDS } from '../../hooks/useClientNames';
import { createBatchedLookup } from './batchedLookup';
import { csvRequestConfig } from './csvExport';

/**
 * Client names for an export's rows, 100 ids a request. Make one per export.
 * An id the API doesn't return maps to '' and is left blank, as on screen.
 */
export const createClientNameLookup = (workspaceId: string) =>
  createBatchedLookup({
    batchSize: MAX_CLIENT_IDS,
    fetchBatch: async (clientIds, signal) => {
      const { items } = await fetchClientsPaginated(
        { clientIds, pageSize: MAX_CLIENT_IDS, workspaceId },
        csvRequestConfig(signal),
      );

      return items.flatMap(({ _id, clientName }) =>
        _id ? [[_id, clientName] as const] : [],
      );
    },
    missing: '',
  });
